var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17.088px",
    height: "40.216px",
    viewBox: "0 -1361 944 2222",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "MJX-5-TEX-LO-222B",
    d: "M114 -798Q132 -824 165 -824H167Q195 -824 223 -764T275 -600T320 -391T362 -164Q365 -143 367 -133Q439 292 523 655T645 1127Q651 1145 655 1157T672 1201T699 1257T733 1306T777 1346T828 1360Q884 1360 912 1325T944 1245Q944 1220 932 1205T909 1186T887 1183Q866 1183 849 1198T832 1239Q832 1287 885 1296L882 1300Q879 1303 874 1307T866 1313Q851 1323 833 1323Q819 1323 807 1311T775 1255T736 1139T689 936T633 628Q574 293 510 -5T410 -437T355 -629Q278 -862 165 -862Q125 -862 92 -831T55 -746Q55 -711 74 -698T112 -685Q133 -685 150 -700T167 -741Q167 -789 114 -798Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    transform: "matrix(1 0 0 -1 0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "math"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mo"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#MJX-5-TEX-LO-222B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegral);
export default __webpack_public_path__ + "static/media/integral.343d97c1cab6adee4654ce4dc382abad.svg";
export { ForwardRef as ReactComponent };